import axios from "axios";

export const state = {
    smspurchases: [],
};

export const getters = {
    smspurchases: state => state.smspurchases,
};

export const mutations = {
    setSmsPurchases(state, newValue) {
        state.smspurchases = newValue
    },
};

export const actions = {
    fetchSmsPurchases({ commit }) {
        axios.get('/smspurchases').then(res => {
            commit('setSmsPurchases', res.data.purchases)
        })
    },
};
